import React from "react";
import { Images } from "./images";
import Image from "gatsby-image";
import Opengraph from "../../../../assets/images/cases/ppwb/og.png"
import Video from "../../../../assets/videos/rowerowa-przygoda/video.mp4";
import Audio from "../../../../assets/audio/ppwb/audio.mp3";
import BannerIcon from "../../../../assets/icons/cases/banner-icon.svg";

export const PpwbData = () => {
  const images = Images();
  return {
    color: "#fff",
    title: "Kampania promocyjno-informacyjna - promocja urzędu Województwa Podkarpackiego",
    seo: "Kampania promocyjno-informacyjna - promocja urzędu Województwa Podkarpackiego",
    description: 'Kampania promocyjna w internecie i poza nim',
    slug: "ppwb",
    opengraph: Opengraph,
    hero: {
      title: "Kampania promocyjno-informacyjna - promocja urzędu Województwa Podkarpackiego",
      color: "#fff",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Kampania promocyjna w internecie i poza nim",
      technologies: [
        "Kampania online",
        "Telewizja",
        "Prasa",
        "Radio",
      ],
      text:
        "Przygotowaliśmy i zrealizowaliśmy kampanię poświęconą promocji projektu - Podkarpackiej Platformy Wsparcia Biznesu. Grupą docelową kampanii reklamowej byli zarówno przedsiębiorcy świadczący usługi rozwojowe, jak i ci, którzy chcą otrzymać refundację za zakup takiej usługi z województwa podkarpackiego. W naszych działaniach skupiliśmy się także na osobach świadczących usługi doradcze z całej Polski. Promocja i marketing odbywały się w internecie i w mediach tradycyjnych. Ich celem była aktywacja przedsiębiorców z województwa, zachęcenie do skorzystania z projektu oraz podjęcie związanych z nim działań. Obszar kampanii reklamowej był ogólnopolski.",
      list: [
        "Stworzyliśmy harmonogram działań i media plan kampanii",
        "Wymyśliliśmy hasła i slogan przewodni kampanii",
        "Stworzyliśmy storytelling w postaci ciekawych historii",
        "Zaprojektowaliśmy Key Visual - brand book",
        "Przygotowaliśmy kreacje reklamowe online i offline do portali biznesowych, finansowych i informacyjnych",
        "Wyprodukowaliśmy spoty radiowe i telewizyjne",
        "Tworzyliśmy artykuły promocyjno-informacyjne",
        "Kompleksowo prowadziliśmy profile w mediach społecznościowych",
      ],
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    contact_banners: {
      first: {
        icon: BannerIcon,
        title: 'Działania promocyjno-informacyjne dla Twojej instytucji',
        text: <>
          Chcesz zrealizować podobną kampanię? Napisz do nas ->
          <br/>
          Jeżeli chcesz szczegółowo poznać nasze działania, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      },
      second: {
        icon: BannerIcon,
        title: 'Kompleksowa kampania promocyjno-informacyjna ',
        text: <>
          Chcesz zrealizować podobne cele? Napisz do nas ->
          <br/>
          Jeżeli podoba Ci się ten projekt, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      },
      third: {
        icon: BannerIcon,
        title: 'Wzmocnij pozycję swojego sklepu internetowego',
        text: <>
          Nie masz czasu, żeby przeczytać więcej? Napisz do nas ->
          <br/>
          Jeżeli potrzebujesz więcej informacji, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      }
    },
    headers: {
      first: "Nasz klient",
      second: "",
    },
    text_boxes: {
      first: {
        title: "Promocja i marketing projektu PPWB",
        text: <>
          Nasze działania zaczęliśmy od opracowania koncepcji i strategii kreatywnej, która uwzględniała kampanię promocyjną w internecie oraz w prasie, radiu i telewizji regionalnej. Stworzyliśmy szczegółowy harmonogram działań, określiliśmy ramy czasowe poszczególnych etapów projektu, wykonaliśmy media plan kampanii. Przygotowaliśmy grafiki, hasła reklamowe, artykuły promocyjne i informacyjne, spoty telewizyjne i radiowe, które następnie wykorzystywaliśmy w promocji i marketingu. Wszystko systematycznie raportowaliśmy, dzięki czemu mogliśmy monitorować efekty kampanii reklamowej dla Województwa Podkarpackiego. Jednym słowem - z sukcesem zrealizowaliśmy kampanię i osiągnęliśmy założone przez klienta cele.
        </>,
      },
      second: {
        title: <>Cele kampanii reklamowej</>,
        text: <>
          • Zbudowanie wizerunku Podkarpackiej Platformy Wsparcia Biznesu, podkreślenie korzyści i zachęcenie do skorzystania z usług i oferty projektu
          <br/> <br/>
          • Wzrost zainteresowania przedsiębiorców z województwa podkarpackiego platformą jako narzędziem do zakupu i sprzedaży okołobiznesowych usług rozwojowych oraz nawiązywania współpracy pomiędzy innymi firmami
          <br/> <br/>
          • Promocja PPWB jako innowacyjnego narzędzia umożliwiającego wsparcie przedsiębiorców z województwa
          <br/> <br/>
          • Zachęcenie ekspertów działających na rynku do rejestrowania się na platformie i świadczenia usług doradczych
          <br/> <br/>
          • Pobudzenie mikro, małych i średnich przedsiębiorstw z województwa podkarpackiego do korzystania z innowacyjnych usług
        </>,
      },
      third: {
        title: 'Kampania promocyjna w internecie',
        text: <>
          Promocja i marketing online polegał na przeprowadzeniu kampanii reklamowej z wykorzystaniem materiałów wideo. Wykorzystaliśmy powstałe materiały filmowe w kampaniach na portalu YouTube oraz serwisach społecznościowych. Zgodnie z opracowaną strategią publikowaliśmy reklamy displayowe w portalach biznesowych, finansowych, informacyjnych oraz w mediach społecznościowych. Prowadziliśmy również kampanię z linków sponsorowanych w wynikach wyszukiwania wyszukiwarki internetowej. Kampania promocyjna w internecie skupiła się także na marketingu treści. Działania z zakresu content marketingu opierały się na napisaniu rzetelnych artykułów i stworzeniu ciekawych infografik. Ponadto prowadziliśmy profile w mediach społecznościowych - na Facebooku, Instagramie oraz LinkedInie.
        </>
      },
      fourth: {
        title: 'Kampania reklamowa w mediach tradycyjnych',
        text: <>
          <strong>Kampania reklamowa w prasie</strong>
          <br/>
          Opracowaliśmy projekt graficzny reklamy prasowej i baneru dostępnego online. Publikacje pojawiały się w wydaniu weekendowym w określonym nakładzie. Przekazywane informacje odsyłały do strony projektu Województwa Podkarpackiego. Grafiki były spójne z opracowanym Key Visual.
          <br/><br/>

          <strong>Kampania reklamowa w radio</strong>
          <br/>
          Wyprodukowaliśmy spot radiowy o długości 30 sekund. Opracowaliśmy scenariusz, zgraliśmy ścieżki dźwiękowe, zaangażowaliśmy lektora, wykonaliśmy mastering. Zorganizowaliśmy emisje w lokalnej i ogólnopolskiej rozgłośni radiowej w wybranym primetime.
          <br/><br/>

          <strong>Kampania reklamowa w telewizji regionalnej</strong>
          <br/>
          Wyprodukowaliśmy spot o długości 30 sekund. Opracowaliśmy scenariusz i zajęliśmy się realizacją postprodukcji w zakresie oprawy graficznej każdego filmu - czołówka, wstawki pomiędzy ujęciami, tyłówka, animacje komputerowe. W materiale wystąpili i profesjonalni aktorzy, i nowoczesne efekty wizualne. W ramach kampanii zapewniliśmy emisje spotów reklamowych w telewizji.
          <br/><br/>
        </>
      },
      fifth: {
        title: 'Podsumowanie kampanii reklamowej',
        text: <>
          Cała kampania reklamowa trwała 195 dni. W tym czasie zrealizowaliśmy wszystkie założone cele. To była niezwykle ciekawa, kompleksowa podróż, która prowadziła przez kampanię promocyjną w internecie oraz mediach tradycyjnych. Ten czas był dla nas bardzo owocny - cały zespół doskonalił swoje umiejętności, czego efektem jest skuteczna promocja i marketing Podkarpackiej Platformy Wsparcia Biznesu. A jak wiadomo - we love what we do!
        </>
      },
      sixth: {
        title: 'Referencje',
        text: <>
          <strong>
            <i style={{lineHeight: '2.2'}}>
              Usługa została wykonana należycie, z zachowaniem warunków realizacji usługi i terminów określonych w umowie.
            </i>
          </strong>
          <br/> <br/>

          <i style={{lineHeight: '2.2'}}>Zakres zamówienia obejmował:</i>
          <br/>
          <i style={{lineHeight: '2.2'}}>• opracowanie koncepcji: strategicznej i kreatywnej</i> <br/>
          <i style={{lineHeight: '2.2'}}>
            • zaplanowanie, produkcję materiałów i finalną realizację kampanii o charakterze wizerunkowym na terenie całej Polski ze szczególnym uwzględnieniem województwa podkarpackiego za pośrednictwem telewizji regionalnej, prasy radia i Internetu.
          </i>
          <br/> <br/> <br/>
          <p style={{ textAlign: "right" }}>
            <strong>
              Dyrektor Departamentu Gospodarki Regionalnej
              <br/>
              Danuta Cichoń
            </strong>
          </p>
        </>
      },
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_4.childImageSharp.fluid}
        />
      ),
      fifth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_5.childImageSharp.fluid}
        />
      ),
    },
  };
};
